import {
  Activity,
  Bell,
  Calendar,
  Bolt,
  History,
  Home,
  Truck,
  CircleUserRound,
  House,
  BarChart3,
  type LucideIcon,
} from "lucide-react";

// ─── Types ──────────────────────────────────────────────────────

export interface SidebarNavItem {
  title: string;
  url: string;
  icon: LucideIcon;
  exact?: boolean;
  restrictedTo?: string[];
}

// ─── Sidebar nav items ──────────────────────────────────────────

export const COMPANY_SIDEBAR_NAV: SidebarNavItem[] = [
  { title: "Dashboard", url: "/dashboard", icon: House },
  { title: "Chantiers", url: "/sites", icon: Bolt },
  { title: "Notifications", url: "/notifications", icon: Bell },
  {
    title: "Équipes",
    url: "/team",
    icon: CircleUserRound,
    restrictedTo: ["company_director", "project_supervisor"],
  },
  {
    title: "Fournisseurs",
    url: "/fournisseurs",
    icon: Truck,
    restrictedTo: ["company_director", "project_supervisor"],
  },
  {
    title: "Historique",
    url: "/audit-logs",
    icon: History,
    restrictedTo: ["company_director", "project_supervisor"],
  },
];

export const SITE_MANAGER_SIDEBAR_NAV: SidebarNavItem[] = [
  { title: "Dashboard", url: "/site", icon: Home, exact: true },
  { title: "Calendrier", url: "/site/calendar", icon: Calendar },
  { title: "Production", url: "/site/progress", icon: Activity },
  { title: "Planning", url: "/site/planning", icon: BarChart3 },
  { title: "Historique", url: "/site/history", icon: History },
  { title: "Notifications", url: "/site/notifications", icon: Bell },
];
